import type en from '../en/dashboard'
import type { Translation } from '../types'

/** The dashboard: the overview of all sites */
const dashboard: Translation<typeof en> = {
  "dashboard.greeting.morning": "Bonjour, {name}",
  "dashboard.greeting.afternoon": "Bon après-midi, {name}",
  "dashboard.greeting.evening": "Bonsoir, {name}",
  "dashboard.subtitle": "Vue d’ensemble du réseau sur tous vos sites",
  "dashboard.totalSites": "Total des sites",
  "dashboard.acrossAllSites": "Sur tous les sites",
  "dashboard.connectedNow": "Connectés maintenant",
  "dashboard.activeAlerts": "Alertes actives",
  "dashboard.throughput": "Débit du réseau",
  "dashboard.averageOver": "moyenne sur {period}",
  "dashboard.download": "↓ Réception",
  "dashboard.upload": "↑ Envoi",
  "dashboard.allSitesNote": "Tous les sites ensemble. L’historique de chaque site se trouve sur sa page.",
  "dashboard.recentAlerts": "Alertes récentes",
  "dashboard.allAlerts": "Toutes les alertes",
  "dashboard.noAlerts": "Aucune alerte active — tous les systèmes fonctionnent",
  "dashboard.trafficSummary": "Résumé du trafic",
  "dashboard.totalReceived": "Total reçu",
  "dashboard.totalSent": "Total envoyé",
  "dashboard.slowestSite": "SITE LE PLUS LENT",
  "dashboard.avg": "{rate} en moyenne",
}

export default dashboard
